define('lq/events/actions/pushNotificationsCommand',[
    'lq/events/actions/eventAction'
], function (EventAction) {
    'use strict';

    function PushNotificationsCommand(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        return this;
    }

    EventAction.extend(PushNotificationsCommand, EventAction);

    PushNotificationsCommand.typeName = 'PushNotificationsCommand';

    PushNotificationsCommand.prototype.getBatchType = function () {
        return EventAction.COMMAND_BATCH;
    };

    PushNotificationsCommand.prototype.createEventActionRequest = function () {
        return {
            eventActionType: 'PushNotifications',
            command: this.eventData.command
        };
    };

    return PushNotificationsCommand;
});
